import stockMovement from './stock-movement'
import stockReservation from './stock-reservation'
import stockInversion from './stock-inversion'
import stockPosition from './stock-position'
import stockRetroactive from './stock-retroactive'
import stockInventory from './stock-inventory'
import stockCounting from './stock-counting'
import stockCountingRules from './stock-counting-rules'
import stockCountingDashboard from './stock-counting-dashboard'

export default {
  namespaced: true,
  modules: {
    stockMovement,
    stockReservation,
    stockPosition,
    stockInversion,
    stockInventory,
    stockRetroactive,
    stockCounting,
    stockCountingRules,
    stockCountingDashboard,
  },
  state: {},
  mutations: {},
  actions: {},
}
